module.exports = __webpack_public_path__ + "static/media/logo_unijui.6541fd55.png";